export const FETCH_NOTIFICATION_COUNTER_BEGIN = "FETCH_NOTIFICATION_COUNTER_BEGIN";
export const FETCH_NOTIFICATION_COUNTER_SUCCESS = "FETCH_NOTIFICATION_COUNTER_SUCCESS";
export const FETCH_NOTIFICATION_COUNTER_FAILURE = "FETCH_NOTIFICATION_COUNTER_FAILURE";

export const fetchNotificationCounterBegin = () => ({
    type: FETCH_NOTIFICATION_COUNTER_BEGIN
});

export const fetchNotificationCounterSuccess = nc => {
    return {
        type: FETCH_NOTIFICATION_COUNTER_SUCCESS,
        payload: {notificationCounter: nc}
    };
};
export const fetchNotificationCounterFailure = error => ({
    type: FETCH_NOTIFICATION_COUNTER_FAILURE,
    payload: {error}
});
